const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentFeaturedVideo extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}

		this.imageElement = this.querySelector('.component-featured-video__image');
		this.iframeElement = this.querySelector('.component-featured-video__video iframe');

		if (this.imageElement) {
			this.imageElement.addEventListener('click', () => {
				this.loadIframeSrc(true);
				this.hideCoverImage();
			});
		}
		else {
			this.loadIframeSrc();
		}

		this.initialized = true;

	}

	loadIframeSrc(autoplay = false) {
		if (this.iframeElement) {
			let dataSrc = this.iframeElement.getAttribute('data-src');
			if (autoplay) {
				dataSrc = dataSrc + '&autoplay=1';
			}
			this.iframeElement.setAttribute('src', dataSrc);
		}
	}

	hideCoverImage() {
		if (this.imageElement) {
			this.imageElement.classList.add('hide');
		}
	}

}

customElements.define('component-featured-video', ComponentFeaturedVideo, {extends: 'div'});